var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRv = function SvgRv(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 38.503 27.071"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.427 13.604 4.893 13.467h5.58l-4.892-13.467zM33.2.033l-4.575 13.216-4.788 13.821h5.303l4.787-13.822L38.503.034H33.2ZM0 13.214v13.82h5.165V0H0Z"
  })));
};
export default SvgRv;